import PopImg from "../assets/popupImg.png";
import IconClose from "../../../assets/icones/icons dense (24px)/fechar - white.svg";
import { Overlay, Wrapperbanner, WrapperClose } from "./styles";
import React from "react";

interface PopUpProps {
  close: () => void;
}
const PopUp = ({ close }: PopUpProps) => {
  return (
    <Overlay>
      <Wrapperbanner>
        {/* <a
          href="https://coobrasturltda.sharepoint.com/:b:/s/EQP-MARKETING-EXT/EdCuALty1uBMhC6WDBSlltEBuqL_j2KiYS4wqGcZmSQmiQ?e=uezLdX"
          target="_blanck"
        >
          <img
            src={PopImg}
            alt="lista de hoteis credenciados, clique aqui"
            width="100%"
          />
        </a> */}
        <h2>
          Comunicado Importante: Interrupção Temporária dos Serviços de Telefonia
        </h2>
        <p>
          Prezados assinante,
          <br/><br/>
          Gostaríamos de informar que, devido às condições climáticas adversas no sul do país, 
          estamos enfrentando uma interrupção temporária nos nossos serviços de telefonia. As 
          fortes chuvas que têm ocorrido na região impactaram diretamente a nossa capacidade de 
          manter a conectividade.
          <br/><br/>
          Nossa equipe está trabalhando diligentemente para resolver essa questão o mais rápido 
          possível e restabelecer os nossos serviços de atendimento. No entanto, enquanto isso não 
          acontece, pedimos a compreensão de todos os nossos clientes.
          <br/><br/>
          Entendemos que algumas situações podem exigir atenção imediata. Por isso, em casos urgentes 
          que necessitem de suporte ou atendimento, solicitamos que entrem em contato conosco através 
          do e-mail atendimento@xxxx para que possamos auxiliá-los da melhor forma possível.
          <br/><br/>
          Pedimos desculpas por qualquer inconveniente que essa situação possa causar e agradecemos 
          pela paciência e compreensão de todos.
        </p>
        <WrapperClose>
          <img
            src={IconClose}
            alt="fechar-popUp"
            onClick={close}
            width="100%"
          />
        </WrapperClose>
      </Wrapperbanner>
    </Overlay>
  );
};

export default PopUp;
